import { MatDialog } from "@angular/material/dialog";
import { TranslateService } from "@ngstack/translate";
import { Component, OnInit, ViewChild } from "@angular/core";
import { MatPaginator } from "@angular/material";
import { IRegister } from "src/app/interfaces/register";
// import { InvoiceService } from "src/app/services/http/business/invoice/invoice.service";
import { PaymentService } from "src/app/services/http/business/payment/payment.service";
import { StaticValueService } from "src/app/services/http/business/staticValue/static-value.service";
import { FormGroup, FormBuilder } from "@angular/forms";
import { StudentService } from "src/app/services/http/business/student/student.service";
import { InvoiceSummaryComponent } from "src/app/pages/finance/payment/invoice-summary/invoice-summary.component";
import { InvoiceDetailsComponent } from "src/app/pages/finance/invoice/invoice-details/invoice-details.component";
import { IConfirm } from "src/app/interfaces/confirm";
import { ConfirmComponent } from "src/app/components/confirm/confirm.component";
import { SoundEnum } from "src/app/enums/sound.enum";
import { InvoiceService } from "src/app/services/http/business/invoice/invoice.service";
import { SnackBarService } from "src/app/services/common/snackBar.service";
//import { PlacementService } from "src/app/services/http/business/placement/placement.service";
//import { debug } from "console";

@Component({
  selector: 'app-subsidiary-dashboard-contract-financial',
  templateUrl: './subsidiary-dashboard-contract-financial.component.html',
  styleUrls: ['./subsidiary-dashboard-contract-financial.component.css']
})
export class SubsidiaryDashboardContractFinancialComponent implements OnInit {
  invoiceList: any;
  form: FormGroup;
  filter: any;
  invoiceTypeList = [];
  InvoiceStatusList = [];
  @ViewChild(MatPaginator) paginator: MatPaginator;
  dataSource: any = [];
  displayedColumns: string[] = [
    "invoiceCode",
    "branch",
    "invoiceType",
    "creationDateInvoice",
    'payDate',
    "payPerson",
    "price",
    "remaining",
    // "priceDiscount",
    "invoiceStatus",
    "function",
    "placement"
  ];
  pageSize: number;
  pageIndex: number;
  userInfo: IRegister;

  constructor(
    private fb: FormBuilder,
    private dialog: MatDialog,
    private staticValueService: StaticValueService,
    public translate: TranslateService,
    private invoiceService: InvoiceService,
    private snackBar: SnackBarService,
    //private placementService: PlacementService,
    private studentService: StudentService,
    private paymentService: PaymentService,
    // private invoiceService: InvoiceService,
    // private bidService: BIDService
  ) { }

  ngOnInit() {
    this.createForm();
    this.getInvoices();
    this.getAllInvoiceItemType();
    this.getInvoiceStatus();
    // this.companySelected = this.cidService.getCID();
  }
  createForm() {
    this.form = this.fb.group({
      InvoiceItemTypeId: [null],
      InvoiceCounterNumber: [null],
      InvoiceStatusId: [null],
    });

  }
  //
  getAllInvoiceItemType() {

    this.staticValueService.allInvoiceItemType().subscribe(
      res => {
        this.invoiceTypeList = res;
      },
      err => {
        console.log(err);
      }
    );
  }

  // placementDetails(e) {
  //   var _filter = {
  //     Id: e.SourceId
  //   };
  //   this.placementService.list(_filter, null, 1, 10).subscribe(res => {
  //     this.dialog
  //       .open(PlacementDetailComponent, {
  //         data: res.DataList[0],
  //         width: '400px'
  //       });

  //   });
  // }


  cancelPayment(e) {
    let confirm: IConfirm = {
      accept: true,
      message: this.translate.get("confirm.invoiceCancelConfirm"),
      alert: null,
      yesLabel: this.translate.get("label.yes"),
      noLabel: this.translate.get("label.no")
    };
    this.dialog
      .open(ConfirmComponent, {
        width: "700px",
        data: confirm
      })
      .afterClosed()
      .subscribe(res => {
        if (res) {
          this.invoiceService.cancelInvoice({ Id: e.Id }).subscribe(() => {
            this.snackBar.OpenSnackBar(
              this.translate.get("success.invoiceCanceled"),
              "ok",
              3000,
              SoundEnum.beep
            );
            this.refresh();
            // this.invoiceService.invoiceCompanyAll(this.filter, this.paginator.pageIndex + 1, this.paginator.pageSize).subscribe(res => {
            //   this.dataSource = res.DataList;
            //   this.paginator.length = res.Total;
            // });
          },
            () => {
              this.snackBar.OpenSnackBar(
                this.translate.get("error.invoiceCanceledFaild"),
                "ok",
                3000,
                SoundEnum.beep
              );
            })

        }
      });


    // console.log(e);
    // this.dialog.open(RefoundEntryComponent, {
    //   width: "400px",
    //   data: e
    // })
    //   .afterClosed()
    //   .subscribe(() => {
    //     this.invoiceService.invoiceCompanyAll(this.filter, this.paginator.pageIndex + 1, this.paginator.pageSize).subscribe(res => {
    //       this.dataSource = res.DataList;
    //       this.paginator.length = res.Total;
    //     });
    //   });
  }

  detailsInvoice(item: any) {
    item.isStudent = true;
    this.dialog
      .open(InvoiceDetailsComponent, {
        width: '75%',
        data: item
      })
      // .afterClosed()
      // .subscribe(res => {
      //
      //   console.log(res);
      //   this.filter = res
      //    this.getInvoices();

      // })
      ;
  }

  //
  getInvoiceStatus() {
    this.staticValueService.invoiceStatus().subscribe(
      res => {
        this.InvoiceStatusList = res;
      },
      err => {
        console.log(err);
      }
    );
  }

  search(form: any) {
    this.dataSource = null;
    this.filter = form;
    this.getInvoices();
  }

  refresh() {
    this.dataSource = null;
    this.createForm();
    this.filter = null;
    this.getInvoices();
  }

  getInvoices() {
    this.studentService.getInvoiceComonSTU(this.filter).subscribe(res => {

      this.dataSource = res.DataList;
      this.paginator.length = res.Total;
      this.paginator.pageIndex = 0;
      this.paginator.pageSize = 0;
    });
  }
  paginatorEvent(event) {
    this.studentService.getInvoiceComonSTU(this.filter, event.pageIndex + 1, event.pageSize).subscribe(res => {
      this.pageSize = event.pageSize;
      this.pageIndex = event.pageIndex + 1;
      this.dataSource = res.DataList;
      this.paginator.length = res.Total;
    });
  }

  pay(element: any) {
    let payParams = {
      ListCouponId: [],
      CompanyDiscount: 0,
      Id: element.Id,
      IsStudent: true,
      // CompanyEncryptId:element.CompanyEncryptId
    };
    if (element.Price == 0) {
      this.paymentService.pay(payParams, 'melli').subscribe(() => {
        this.dataSource = null;
        this.getInvoices();
      });
    } else {
      this.dialog.open(InvoiceSummaryComponent, {
        width: '98%',
        data: payParams
      })
        .afterClosed()
        .subscribe(() => {

          let paginatorParams = {
            pageIndex: this.paginator.pageIndex,
            pageSize: this.paginator.pageSize
          };
          this.paginatorEvent(paginatorParams);
        });
    }
  }

  getColor(e) {
    switch (e.InvoiceStatusId) {
      case 50:
        return "custom-chips success";
      case 51:
        return "custom-chips accent";
      case 52:
        return "custom-chips accent";
      case 53:
        return "custom-chips accent";
      case 54:
        return "custom-chips accent";
      case 55:
        return "custom-chips default";
      default:
        return "custom-chips default";
    }
  }

  // refound(invoiceDeadLine: any) {
  //   const params = {
  //     invoiceDeadLine: invoiceDeadLine
  //   };
  //   this.dialog.open(RefoundEntryComponent, {
  //     data: params
  //   })
  //     .afterClosed()
  //     .subscribe(() => {
  //       //this.paginatorEvent(this.paginator);

  //     });
  // }

}
